import { AlarmsDTO, DataVersion } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAlarms(
  searchParams: string,
  refetchInterval?: number,
  onSuccess?: (data: AlarmsDTO) => void,
  disabled = false,
  keepPreviousData = false,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/alarm?${searchParams}`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<AlarmsDTO>(request, {
    queryKey: ['alarms', { searchParams, dataVersion }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval,
    refetchIntervalInBackground: true,
    onSuccess,
    enabled: !disabled,
    keepPreviousData,
  });
}

export default useAlarms;
